const dayjs = require('dayjs')
import 'dayjs/locale/es-mx'

const relativeTime = require('dayjs/plugin/relativeTime')
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("America/Mexico_City")

dayjs.locale('es-mx')

export const isoDate = (date) => {
    const format_date = dayjs.utc(date).toDate()
    const timePart = dayjs(format_date).tz('UTC').format("HH:mm:ss:SSS")
    const datePart = dayjs(format_date).tz('UTC').format("YYYY-MM-DD")
    const dateISO8601 = `${datePart} ${timePart}`
    return dateISO8601
}

export const formatToday = () => {
    const date = new Date()
    return dayjs(date).format("YYYY-MM-DD")
}

export const formattedDate = (date) => {
    const format_date = dayjs.utc(date).toDate()
    const datePart = dayjs(format_date).tz('UTC').format("YYYY-MM-DD")
    return datePart
}
export const formattedDateExtended = (date) => {
    const format_date = new Date(isoDate(date))
    return date ? dayjs(format_date).format("DD MMMM YYYY") : ''
}

export const formattedDatePicker = (date) => {
    const format_date = new Date(date)
    return dayjs(format_date).format("YYYY-MM-DD")
}

export const formattedDateTimePicker = (date) => {
    const format_date = new Date(date)
    return dayjs(format_date).format("YYYY-MM-DD HH:mm:ss")
}

export const relativeDate = (date) => {
    return date ? dayjs.tz(date).fromNow() : 'nunca'
}

/**
 * Formats a date by adding a specified number of days to today's date
 * @param {number} date - Number of days to add to today's date
 * @returns {string} Formatted date string in 'YYYY-MM-DD' format
 * @example
 * // Returns today's date plus 7 days formatted as 'YYYY-MM-DD'
 * formattedDateFlatpickrPlus(7)
 */
export const formattedDateFlatpickrPlus = (date) => {
    const today = new Date()
    const days = 1000 * 60 * 60 * 24 * date
    const plus = today.getTime() + days
    const dateLimit = new Date(plus)
    return dayjs(dateLimit).format("YYYY-MM-DD")
}


/**
 * Calculates a date by adding a specified number of days to a given date.
 * @param {Date|string|number} date - The starting date
 * @param {number} days - The number of days to add
 * @returns {string} The resulting date formatted as "YYYY-MM-DD"
 */
export const datePlusDays = (date, days) => {
    const today = new Date(date)
    const daysInMs = 1000 * 60 * 60 * 24 * days
    const plus = today.getTime() + daysInMs
    const dateLimit = new Date(plus)
    return dayjs(dateLimit).format("YYYY-MM-DD")
}

export const formattedDateFlatpickrLess = (date) => {
    const today = new Date()
    const days = 1000 * 60 * 60 * 24 * date
    const plus = today.getTime() - days
    const dateLimit = new Date(plus).toISOString().substring(0, 10)
    return dayjs(dateLimit).format("YYYY-MM-DD")
}

export const dateLimiter = (date) => {
    const today = new Date()
    const diference = (today - new Date(date))
    const days = Math.floor(diference / 86400000)// redondea hacia abajo
    return days
}


/**
 * Determines if a date is blocked based on current date and time conditions.
 * 
 * @param {Date|string} date - The date to check against current date/time
 * @returns {boolean|undefined} - Returns false if the date is today, true if the current time is after 11:59:59 and the date is not today, undefined otherwise
 * 
 * @example
 * dateBlocked(new Date('2024-01-15')) // true if current time > 11:59:59 and today is not 2024-01-15
 * dateBlocked(new Date()) // false if the date is today
 */
export const dateBlocked = (date) => {
    const today = dayjs.utc(new Date()).toDate()
    const todayTimePart = dayjs(today).tz('UTC').format("HH:mm:ss:SSS")
    const todayDatePart = dayjs(today).tz('UTC').format("YYYY-MM-DD")

    const format_date = dayjs.utc(date).toDate()
    const datePart = dayjs(format_date).tz('UTC').format("YYYY-MM-DD")

    if (today === datePart) return false

    if (todayDatePart !== datePart && todayTimePart > '11:59:59:000') return true
}


export const muiOnlyDate = (date) => {
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/
    if (dateFormatRegex.test(date)) {
        const tempDate = `${date} 01:00:00`
        const format_date = new Date(tempDate)
        return format_date
    }
}

export const getDateToFilterAPI = (date) => {
    if (!date || !date.start || !date.end) return ''
    return `end=${formattedDatePicker(date.end)} 23:59:59&start=${formattedDateTimePicker(date.start)}`
}

export const getDateToFilterAPISimple = (date) => {
    if (!date) return ''
    return `end=${formattedDatePicker(date.end)}&start=${formattedDatePicker(date.start)}`
}

export const hours = new Date().getHours()
export const minutes = new Date().getMinutes()
export const seconds = new Date().getSeconds()
export const miliseconds = new Date().getMilliseconds()


/**
 * @param {Date|string|number} date - Fecha a la que se le pega la hora actual
 * @returns {string} Fecha y hora como "YYYY-MM-DD HH:mm:ss.SSS"
 */
export const getTimestamp = (date) => {
    return `${dayjs(date).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss.SSS")}`
}

/**
 * Gets the first day of the current month.
 * @returns {string} The first day of the current month formatted as "YYYY-MM-DD"
 * @example
 * getFirstDayOfMonth() // "2024-06-01" if the current month is June 2024
 */
export const getFirstDayOfMonth = () => {
    const today = new Date()
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
    return dayjs(firstDay).format("YYYY-MM-DD")
}